import camelCase from "lodash.camelcase";
import snakeCase from "lodash.snakecase";

type ChangeCase = (string: string, f?: any, g?: any[]) => string;
type Predicate = (key: string) => boolean;

const defaultPredicate: Predicate = (key) => !key.startsWith("_");

/** @deprecated Use `convertKeys` instead to preserve type safety */
export const changeKeysDeepWith = (
  changeCase: ChangeCase,
  predicate: Predicate = defaultPredicate,
  shouldChangeChildren: Predicate = () => true,
) => {
  // The second argument is not used, it's there only to allow this function be
  // passed to map()
  const changeKeysDeep = (input: any, _?: any, keyPath: any[] = []): any => {
    if (!input || typeof input !== "object") {
      return input;
    }
    if (Array.isArray(input)) {
      return input.map((value, index) => changeKeysDeep(value, null, [index]));
    }
    return Object.entries(input).reduce(
      (cased: Record<string, any>, [key, value]) => {
        const maybeChangeKey = predicate(key)
          ? changeCase(key, value, keyPath)
          : key;
        cased[maybeChangeKey] = shouldChangeChildren(key)
          ? changeKeysDeep(value, null, [...keyPath, key])
          : value;
        return cased;
      },
      {},
    );
  };
  return changeKeysDeep;
};

/** @deprecated Use `snakeToCamel` instead to preserve type safety */
export const camelCaseKeysDeep = changeKeysDeepWith(camelCase);

/** @deprecated Use `camelToSnake` instead to preserve type safety */
export const snakeCaseKeysDeep = changeKeysDeepWith(snakeCase);
